<template>
    <div class="com-item" :key="index">
        <div class="component person-nav">
            <div class="van-sticky">
                <div class="ql-editor bar" style="min-height:auto;" :style="{padding:'0 '+(modata.WContent.moduleSpac||0)*proportion+'px',backgroundColor:modata.WContent.BgColor||'transparent'}">
                    <div v-html="modata.WContent.textHtml" :style="{height:modata.WContent.textHtml?'auto':'100px'}" style="width:100%;"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {isMobile} from "@/utils/index"
    export default {
        name: 'text-module',
        props: {
            type: {         //展示类型 preview预览模块 setting设置模块
                type: String,
                default: 'preview'
            },
            isactive: {     //是否选中
                type: Boolean,
                default: false
            },
            index: {        //索引
                type: Number
            },
             phoneWidth: {
                type: Number,
                default:1280,
            },
            proportion: {
                type: Number,
                default:1,
            },
            curpageWidth: {
                type: Number,
                default:1280,
                },
            modata: {
                type: Object,
                // 对象或数组默认值必须从一个工厂函数获取
                default: function () {
                    return {
                        WName: 'text',
                        Title: '文本模块',
                        MID: 5,
                        WID: 1,
                        ModuleName: 'text-module',
                        WContent: {
                            textHtml:"",
                            moduleSpac:0,
                        },

                    }
                }
            }
        },
        data() {
            return {
                moduleSpac:"",
               rootValue:this.$store.state.rootValue||1,
            }
        },
        mounted() {
            //  if(isMobile()){
            //       this.moduleSpac="";
            //       let spac= this.modata.WContent.moduleSpac||0;
            //       spac=spac/this.phoneWidth*this.curpageWidth;
            //       this.moduleSpac="0 "+(spac/this.rootValue)+'rem'
            //    }else{
            //     this.moduleSpac="0 "+((this.modata.WContent.moduleSpac||0)/this.rootValue)+'rem'

            //    }
            
            
        },
        methods: {
           

        },

    }
</script>
<style scoped>
    .com-item .bar {
        margin: 0 auto;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        position: relative;
        overflow:hidden;
        color: #333;
    }
 
</style>
